import { Cookies } from 'react-cookie-consent'
import { AQUADB_COOKIE, AQUADB_EXPIRE_DAYS } from './constants/CookieConstants'
import DtoCookie from './dto/DtoCookie'
import ReactGA from 'react-ga'

const createCookie = (key, value) => {
	Cookies.set(key, value, { expires: Number(AQUADB_EXPIRE_DAYS) })
}
const deleteCookie = (key) => {
	Cookies.remove(key)
}

const getCookie = (key) => {
	return Cookies.get(key)
}

const purgeAquaDBCookies = () => {
	deleteCookie(AQUADB_COOKIE)
}

const checkCookies = () => {
	if (!getCookie(AQUADB_COOKIE)) {
		purgeAquaDBCookies()
		return true
	}
	return false
}

const getAquaDBCookie = () => {
	const result = getCookie(AQUADB_COOKIE)
	if (result) {
		return new DtoCookie(JSON.parse(result))
	}
	return undefined
}

const initCookieOption = () => {
	const aquadbCookie = getAquaDBCookie()
	if (aquadbCookie) {
		if (aquadbCookie.statisticsCookies) {
			ReactGA.initialize('UA-90991121-1')
		}
	}
}
const putAnalyticsCookieUser = (login) => {
	const aquadbCookie = getAquaDBCookie()
	if (aquadbCookie) {
		if (aquadbCookie.statisticsCookies && login) {
			ReactGA.set({ userId: login })
		}
	}
}

const getPageViewAnalytics = (viewPageHash) => {
	const aquadbCookie = getAquaDBCookie()
	if (aquadbCookie) {
		if (aquadbCookie.statisticsCookies) {
			ReactGA.pageview(viewPageHash)
		}
	}
}
export {
	checkCookies,
	createCookie,
	deleteCookie,
	purgeAquaDBCookies,
	getCookie,
	getAquaDBCookie,
	initCookieOption,
	getPageViewAnalytics,
	putAnalyticsCookieUser
}




// WEBPACK FOOTER //
// ./src/utils/cookie/CookieUtils.js